/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfFileRevisionResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type PaginatedResultOfFileRevisionResponse } from '../../../models/index.js';
// @ts-ignore
import { ArchivedRequestBuilderRequestsMetadata, type ArchivedRequestBuilder } from './archived/index.js';
// @ts-ignore
import { type WithRevisionItemRequestBuilder, WithRevisionItemRequestBuilderNavigationMetadata, WithRevisionItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { PendingRequestBuilderNavigationMetadata, PendingRequestBuilderRequestsMetadata, type PendingRequestBuilder } from './pending/index.js';
// @ts-ignore
import { type UploadRequestBuilder, UploadRequestBuilderNavigationMetadata } from './upload/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/revisions
 */
export interface RevisionsRequestBuilder extends BaseRequestBuilder<RevisionsRequestBuilder> {
    /**
     * The archived property
     */
    get archived(): ArchivedRequestBuilder;
    /**
     * The pending property
     */
    get pending(): PendingRequestBuilder;
    /**
     * The upload property
     */
    get upload(): UploadRequestBuilder;
    /**
     * Gets an item from the ApiSdk.files.item.revisions.item collection
     * @param revisionId Unique identifier of the item
     * @returns {WithRevisionItemRequestBuilder}
     */
     byRevisionId(revisionId: Guid) : WithRevisionItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfFileRevisionResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<RevisionsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfFileRevisionResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<RevisionsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface RevisionsRequestBuilderGetQueryParameters {
    page?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const RevisionsRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/revisions{?page*,pageSize*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const RevisionsRequestBuilderNavigationMetadata: Record<Exclude<keyof RevisionsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byRevisionId: {
        requestsMetadata: WithRevisionItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithRevisionItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["revisionId"],
    },
    archived: {
        requestsMetadata: ArchivedRequestBuilderRequestsMetadata,
    },
    pending: {
        requestsMetadata: PendingRequestBuilderRequestsMetadata,
        navigationMetadata: PendingRequestBuilderNavigationMetadata,
    },
    upload: {
        navigationMetadata: UploadRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const RevisionsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: RevisionsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfFileRevisionResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
